var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-map-popover',{staticClass:"store-map-popover",attrs:{"title":_vm.name,"address":_vm.address}})}
var staticRenderFns = []

export { render, staticRenderFns }